import request from '@/utils/request';

//分页查询活动数据列表
export function getActivityManageList(values) {
  return request('/allMarket/activityReport/queryActivityDataPage', {
    method: 'POST',
    data: values,
  });
}
//对比
export function queryComparison(values) {
  return request('/allMarket/activityReport/queryComparison', {
    method: 'POST',
    data: values,
  });
}
